export const DIGESTS_CHANGE_DISPLAY = 'DIGESTS_CHANGE_DISPLAY';



// WEBPACK FOOTER //
// ./src/redux_related/digestsDisplay/actions.js